import { useQuery } from "@connectrpc/connect-query";
import { ShopService } from "@viajero/proto/guest/v1";
import { useTranslation } from "react-i18next";
import { isValidId } from "@/lib/id";

/**
 * ShopService.GetShopDetail を connect-query (`@connectrpc/connect-query`) でラップするフック。
 *
 * 店舗詳細画面 (/{caseToken}/{shopId}) で店舗情報・商品一覧・注意事項を取得する (JPTP_CANSEI-1256)。
 * `x-case-token` ヘッダは lib/client.ts の caseTokenInterceptor が付与するため、呼び出し側は
 * shopId のみを意識すればよい。表示言語は現在の i18n 言語をそのまま RPC に渡し、
 * backend 側で該当言語行が無ければ en にフォールバックする。
 *
 * shopId は URL パラメータ (文字列) を受け取り、proto の int64 (bigint) へ変換する。
 * 数値でない場合は無効な shopId として問い合わせを無効化する。
 */
export function useGetShopDetail(shopId: string, enabled: boolean) {
  const { i18n } = useTranslation();
  const validShopId = isValidId(shopId);
  return useQuery(
    ShopService.method.getShopDetail,
    { shopId: validShopId ? BigInt(shopId) : 0n, languageCode: i18n.language },
    { enabled: enabled && validShopId },
  );
}
